module.exports = __webpack_public_path__ + "img/icon-4.3b067697.png";